module.exports = __webpack_public_path__ + "static/media/sectionDetail.bbacb329.webp";